var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mt-3"},[_c('b-list-group',_vm._l((_vm.userList),function(user,key){return _c('b-list-group-item',{key:key,attrs:{"tag":"a","button":false,"to":{
                    name: 'admin.users.Profile',
                    params: {userId: user.user_id},
                }},nativeOn:{"click":function($event){return _vm.emitSelectedUser(user)}}},[_vm._v(" "+_vm._s(user.fname)+" "+_vm._s(user.lname)+" ("+_vm._s(user.email)+") ")])}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }